<template>
    <div class="brand-filter d-flex flex-wrap" v-if="hasItems">
        <item
            v-for="item in items"
            :key="item.id"
            :value="item"
            :stats="getItemStats(item)"
            v-bind:class="{active: isActive(item)}"
            :base-url="baseUrl"
        ></item>
    </div>
</template>

<script>
  import Item from "./brand-toggle-item";
  import {removeQueryParams} from "../../../libs/url";
  import eventBus from "../../../event-bus";

  export default {
    props: {
      items: {
        type: Array,
      },
      value: {
        type: null,
      },
      clearFilters: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },

    data() {
      return {
        baseUrl: '',
        stats: [],
      };
    },

    computed: {
      /**
       * @return {Object|null}
       */
      activeItem() {
        return _.find(this.items, item => {
          const value = this.value ? this.value : '';
          return String(_.get(item, 'model.id', '')) === value;
        }) || null;
      },

      /**
       * @return {Boolean}
       */
      hasSelectedItem() {
        return !_.isNull(this.activeItem);
      },

      /**
       * @return {Boolean}
       */
      hasItems() {
        return !_.isEmpty(this.items);
      },
    },

    methods: {
      /**
       * @param {Object} item
       */
      isActive(item) {
        return item === this.activeItem;
      },

      /**
       * @param {String} val
       */
      onUrlChange(val) {
        this.baseUrl = removeQueryParams(val, ['brand_id', ...this.clearFilters]);
      },

      /**
       * @param {Array} stats
       */
      updateUnreadStats(stats) {
        this.stats = _.isArray(stats) ? [...stats] : [];
      },

      /**
       * @param {number} id
       * @return {Object|null}
       */
      getItemStats({model: {id}}) {
        return _.find(this.stats, {brand_id: id}) || null;
      },
    },

    mounted() {
      eventBus.$on('url-change', this.onUrlChange);
      eventBus.$on('messages-statistics-update', this.updateUnreadStats);
    },

    beforeDestroy() {
      eventBus.$off('url-change', this.onUrlChange);
      eventBus.$off('messages-statistics-update', this.updateUnreadStats);
    },

    components: {
      Item
    }
  }
</script>
